import ErrorWidget from './ErrorWidget';
export default ErrorWidget;
